import { useMutation } from '@tanstack/react-query';

import { updateOnboardingUser, UserOnboardRequest } from '../../common/api/clients/userOnboard.api';

export const useUserOnboardingUpdate = (userId: string, token: string) => {
    return useMutation({
        mutationFn: (user: UserOnboardRequest) => updateOnboardingUser(userId, token, user),
    });
};
